<!-- StageStatusSelect.vue -->
<template>
  <Select
    :model-value="modelValue"
    @update:model-value="handleUpdate"
    :disabled="disabled"
  >
    <SelectTrigger class="w-full">
      <SelectValue>
        <template v-if="modelValue">
          <div :class="getStatusClass(modelValue)">
            {{ progressStatusChoices[modelValue as keyof typeof progressStatusChoices] }}
            <Loader2
              v-if="isLoading"
              class="animate-spin h-4 w-4 inline ml-1"
            />
          </div>
        </template>
        <span v-else class="text-gray-400">Select status...</span>
      </SelectValue>
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        <SelectItem
          v-for="(value, key) in progressStatusChoices"
          :key="key"
          :value="key"
        >
          <div :class="getStatusClass(key)">
            {{ value }}
          </div>
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>

<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { progressStatusChoices, getStatusClass } from '@/const/progressStatus'

defineProps<{
  modelValue: string
  disabled?: boolean
  isLoading?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const handleUpdate = (value: unknown) => {
  if (typeof value === 'string') {
    emit('update:modelValue', value)
  } else if (value === null) {
    emit('update:modelValue', '')
  }
}
</script> 